import React from 'react';
var MenuHamburguesa = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "25", height: "25", viewBox: "0 0 25 25" },
        React.createElement("g", { id: "menu", transform: "translate(0.5 0.5)" },
            React.createElement("path", { id: "Vector", d: "M0,0H18", transform: "translate(3 7)", fill: "none", strokeLinecap: "round", strokeWidth: "1.5", strokeDasharray: "0 0" }),
            React.createElement("path", { id: "Vector-2", "data-name": "Vector", d: "M0,0H18", transform: "translate(3 12)", fill: "none", strokeLinecap: "round", strokeWidth: "1.5", strokeDasharray: "0 0" }),
            React.createElement("path", { id: "Vector-3", "data-name": "Vector", d: "M0,0H18", transform: "translate(3 17)", fill: "none", strokeLinecap: "round", strokeWidth: "1.5", strokeDasharray: "0 0" }),
            React.createElement("path", { id: "Vector-4", "data-name": "Vector", d: "M24,0V24H0V0Z", fill: "none", strokeWidth: "1", opacity: "0" }))));
};
MenuHamburguesa.defaultProps = {
    className: '',
};
export default MenuHamburguesa;
